import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  materialTypeId: Yup.string().nullable().required('Material Type is required'),
  effectiveDate: Yup.string().nullable().required('Effective Date is required'),
  gross: Yup.string().nullable().required('Gross Weight is required'),
  tare: Yup.string().nullable().required('Tare Weight is required'),
  net: Yup.string().nullable().required('Net Weight is required'),
  type: Yup.string().nullable().required('Type is required'),
})

export const formOptionsGenerator = (maxGross, maxTare) => {
  const validationSchema = Yup.object().shape({
    materialTypeId: Yup.string().nullable().required('Material Type is required'),
    effectiveDate: Yup.string().nullable().required('Effective Date is required'),
    gross: Yup.number().nullable().max(maxGross).required('Gross Weight is required'),
    tare: Yup.number().nullable().min(maxTare).required('Tare Weight is required'),
    net: Yup.string().nullable().required('Net Weight is required'),
    type: Yup.string().nullable().required('Type is required'),
  })
  return { resolver: yupResolver(validationSchema) }
}

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
